import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { IconButton, TextField } from "@mui/material";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";
import { Button } from "react-bootstrap";
import {
    ArrowBackIosNew,
    ArrowForwardIos,
    Circle,
    Square,
    Visibility,
} from "@mui/icons-material";
import { Col, Row } from "reactstrap";
import { useParams } from "react-router-dom";
import { debounce } from "lodash";

const CustomToolbar = ({ onNavigate, selectedDate, setSelectedDate }) => {


    const goToBack = () => {
        const newSelectedDate = moment(selectedDate, "YYYY-MM-DD")
            .subtract(1, "month")
            .format("YYYY-MM-DD");
        setSelectedDate(newSelectedDate);
        onNavigate("date", newSelectedDate);
        // onNavigate('PREV');
    };

    const goToNext = () => {
        const newSelectedDate = moment(selectedDate, "YYYY-MM-DD")
            .add(1, "month")
            .format("YYYY-MM-DD");
        setSelectedDate(newSelectedDate);
        onNavigate("date", newSelectedDate);
        // toolbar.onNavigate('NEXT');
    };


    const bgColor = {
        "PE Pending": "#ed6c02",
        "PE Completed": "#4caf50",
        "PE Created": "#0288d1",
    };

    return (
        <>
            <Row
                className="d-flex justify-content-between  "
            >
                <Col md={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            size="small"
                            views={["month", "year"]}
                            inputVariant={"outlined"}
                            margin="dense"
                            // format="MM/YYYY"
                            label={"Selected Month/Year"}
                            value={selectedDate}
                            KeyboardButtonProps={{ "aria-label": "Selected Month Year" }}
                            onChange={(value) => {
                                const formatDate = value?.$d;
                                const date = formatDate
                                    ? moment(formatDate).format("YYYY-MM-DD")
                                    : null;
                                if (moment(formatDate, 'YYYY-MM-DD').isValid()) {
                                    setSelectedDate(date);
                                    onNavigate("date", date);
                                }


                            }}
                            renderInput={(params) => (
                                <TextField
                                    //   fullWidth
                                    margin="dense"
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                    {...params}
                                />
                            )}
                        />
                    </LocalizationProvider>
                </Col>
                {/* <Col md={2}>
                    <TextField
                        fullWidth
                        size="small"
                        inputProps={{
                            style: {
                                fontSize: "14px",
                                paddingTop: "12px",
                                width: "100%",
                            },
                        }}
                        margin="dense"
                        variant="outlined"
                        label={"Search Employee"}
                        // id={"Search Employee"}
                        value={searchEmployee}
                        InputLabelProps={{ shrink: true }}
                        shrink={true}
                        onChange={handleSearch}
                    />
                </Col> */}
                {/* <Col md={2}>
                    <div className="d-flex justify-content-center align-items-center">
                        <Square style={{ color: "#2196f3", margin: "5px" }} /> PE Pending
                        <Square style={{ color: "#388e3c", margin: "5px" }} /> PE Created
                    </div>
                </Col> */}

                {/* <Col
          md={10}
          className="d-flex justify-content-center align-items-center"
        >
          <IconButton edge="start" aria-label="previous" onClick={goToBack}>
            <Tooltip title="Go to previous month">
              <ArrowBackIosNew />
            </Tooltip>
          </IconButton>
          <h4 className="m-0 p-0">
            {moment(selectedDate, "YYYY-MM-DD").format("MMMM YYYY")}
          </h4>
          <IconButton edge="end" aria-label="next" onClick={goToNext}>
            <Tooltip title="Go to next month">
              <ArrowForwardIos />
            </Tooltip>
          </IconButton>
        </Col>
        <Col md={2}>
          <div className="d-flex justify-content-center align-items-center">
            <Square style={{ color: "#2196f3", margin: "5px" }} /> PE Pending
            <Square style={{ color: "#388e3c", margin: "5px" }} /> PE Created
          </div>
        </Col> */}
                {/* </Row>
            <Row className="d-flex justify-content-between align-items-center mb-2"> */}
                {/* <Col md={2}> */}
                {/* <div className="d-flex justify-content-center align-items-center">
                        <Square style={{ color: "#2196f3", margin: "5px" }} /> PE Pending
                        <Square style={{ color: "#388e3c", margin: "5px" }} /> PE Created
                    </div> */}
                {/* </Col> */}
                <Col
                    md={4}
                    className="d-flex justify-content-center align-items-center"
                >

                    <IconButton edge="start" aria-label="previous" onClick={goToBack}>
                        <Tooltip title="Go to previous month">
                            <ArrowBackIosNew />
                        </Tooltip>
                    </IconButton>
                    <h4 className="m-0 p-0">
                        {moment(selectedDate, "YYYY-MM-DD").format("MMMM YYYY")}
                    </h4>
                    <IconButton edge="end" aria-label="next" onClick={goToNext}>
                        <Tooltip title="Go to next month">
                            <ArrowForwardIos />
                        </Tooltip>
                    </IconButton>
                </Col>
                <Col md={4} className="d-flex justify-content-end align-items-center" >

                    <Square style={{ color: bgColor["PE Pending"], margin: "5px" }} /> PE Pending
                    <Square style={{ color: bgColor["PE Created"], margin: "5px" }} /> PE Created
                    <Square style={{ color: bgColor["PE Completed"], margin: "5px" }} /> PE Completed

                </Col>

            </Row>
        </>
    );
};

export default CustomToolbar;
